import { render, staticRenderFns } from "./SinglePostContent.vue?vue&type=template&id=e21d3e44&"
import script from "./SinglePostContent.vue?vue&type=script&lang=js&"
export * from "./SinglePostContent.vue?vue&type=script&lang=js&"
import style0 from "./SinglePostContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports